import React from 'react';
import moment from 'moment';
/*import UserHelper from '../../../../helper/user.js'
import PermissionProperties from '../../../../config/permission.js'*/

import isEmpty from 'lodash/isEmpty'

export default class UserRow extends React.Component {

  getInfoArr(arr, get_key) {
    if(!isEmpty(arr)) {
      if(arr.hasOwnProperty(get_key)) {
        if(arr[get_key]) {
          return arr[get_key]
        } else {
          return "-"
        }
      }
    }
  }

  // renderRole(){
  //   if(UserHelper.HasPermission(PermissionProperties.USER.ROLE.READ,this.props.UserReducer)){
  //     return (
  //       <span>Role: {this.getInfoArr(this.props.RowData.Role, "Name")} | </span>
  //     )
  //   }else{
  //     return null
  //   }
  // }


  render() {
    let activeProps = {}
    if(this.props.RowData.Active){
    }else{
      activeProps.className="table active text-muted"
    }
    
    return (
      <tr 
        {...activeProps}
        onClick={
          this.props.RowData.Active ? () => this.props.toggleModalUserDetail(this.props.RowData) : () => null
        }
      >
        <td>
          <div><strong >{this.props.RowData.FirstName} {this.props.RowData.LastName} </strong>{'('+this.props.RowData.Username+')'}</div>
          <div className="small text-muted">
            <span>Register: {moment(this.props.RowData.CreatedTime).format('ll')}</span>
            <span className="space">|</span>
            <span>Role: {this.getInfoArr(this.props.RowData.Role, "Name")} | </span>
            <span className="space">Email: <a href={"mailto:" + this.props.RowData.Email + "?Subject=Hello"} target="_top">{this.props.RowData.Email}</a></span>
            <span className="space">|</span>
            <span className="space">Phone: {this.props.RowData.Phone}</span>
          </div>
        </td>
        <td className="text-center">
          <div className={"total-asset" + (this.props.RowData.Active ? "" : " disabled")}>
            {this.props.RowData.AssetsCount} Asset
          </div>
        </td>
        <td>
          <div>
            <strong>{this.getInfoArr(this.props.RowData.City, "Name")}</strong>
          </div>
          <div className="small text-muted user-address">
            <span title="address 1">{this.props.RowData.Address}</span><span className="spaceR">,</span>
            <span title="address 2">{this.props.RowData.Address2}</span><span className="space">-</span>
            <span title="Postal code">{this.props.RowData.Postal}</span>
          </div>
        </td>
        <td>
          {this.props.RowData.Active ? moment(this.props.RowData.CreatedTime).fromNow() : 'Deleted'}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/user/userHaveAsset/helper/component/UserRow.js